import * as actions from './actions';
import getters from './getters';
import mutations from './mutations';

const getInitialState = () => ({
  error: null,
  isLoading: false,
  interactions: [],
  statusMessages: [],
  user: {
    activeQueueNames: null,
    isLoggedIn: false,
    name: null,
    status: null,
    dateStatusChanged: null,
    statusDurationInSeconds: 0,
    customStatus: null,
    reservedCustomStatus: null,
  },
});

export default {
  namespaced: true,
  state: getInitialState(),
  actions,
  getters,
  mutations,
};
